import React from "react";

const SectionLabel = ({ label }) => {
  return (
    <div className="flex items-center pl-[5px] mt-[30px]">
      <div>
        <span className="text-gray-500 uppercase font-bold border-left tigh tracking-widest">
          {label}
        </span>
      </div>
    </div>
  );
};

export default SectionLabel;
